import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../img/defaultUser.svg'
import _imports_1 from '../img/reminder.svg'


const _withScopeId = n => (_pushScopeId("data-v-a7769588"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["element-loading-spinner", "element-loading-text"]
const _hoisted_2 = {
  key: 0,
  class: "tohidden"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "editAvatar" }
const _hoisted_5 = {
  key: 1,
  class: "defaultTohidden"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "defaultImg",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "editAvatar noAvatar" }
const _hoisted_8 = {
  key: 0,
  class: "reminder"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_10 = { class: "bottomBtn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.$t(_ctx.title),
      width: "480px",
      "before-close": _ctx.handleClose,
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["content", _ctx.lang == 'ar' ? 'reverse' : ''])
        }, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "changeavator",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args))),
            "element-loading-spinner": _ctx.svg,
            "element-loading-svg-view-box": "0 0 33 32",
            "element-loading-text": `${_ctx.$t('user.loading')}`,
            "element-loading-background": "rgba(122, 122, 122, 0.8)"
          }, [
            _createVNode(_component_el_upload, {
              action: "#",
              class: "upload-demo",
              "show-file-list": false,
              "http-request": _ctx.changeFile,
              accept: ".jpg,.jpeg,.png"
            }, {
              default: _withCtx(() => [
                (_ctx.userInfo.profile_picture_url || _ctx.tempURL)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("img", {
                        class: "headerAvator",
                        src: _ctx.tempURL,
                        onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.errImg())),
                        alt: ""
                      }, null, 40, _hoisted_3),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("user.changeAvatar")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("user.changeAvatar")), 1)
                    ]))
              ]),
              _: 1
            }, 8, ["http-request"])
          ], 8, _hoisted_1)), [
            [_directive_loading, _ctx.loading]
          ])
        ], 2),
        (_ctx.errorAppend)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", null, _toDisplayString(_ctx.errorText), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_button, {
            type: "primary",
            class: _normalizeClass(["save-style", _ctx.bttDisabled ? 'disableStyle' : '']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("user.save")), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "before-close"])
  ]))
}